import Loading from '../../../Components/Loading';
import { useAppSelector } from '../../../hooks';
import { useEffect, useState } from 'react';
import { ModalHeader, Button, ModalBody, Row, Container } from 'reactstrap';
import { Switch } from '@mui/material';
import { Promo } from './PromotionsReport';
import { toTitleCase } from '../../../Utility/toTitleCase';
import { getWriterId } from '../../SalesDep/Managers/SalesRepView/WriterSlice';
import { Modal } from 'reactstrap';
import './Promotions.css';

type Props = {
    visible: boolean;
    onClose: () => void;
};

const RepPromosModal = ({ visible, onClose }: Props) => {
    const baseUrl = `https://customer.hirsch.com/promos/v2`;
    const [allTag, setAllTag] = useState<boolean>(false);
    const token = useAppSelector((state) => state.auth.token);
    const account = useAppSelector((state) => state.account.accountArr);
    const currentWriter = useAppSelector(getWriterId);
    const writer = !currentWriter ? account.writerKey : currentWriter;
    const [repPromo, setRepPromo] = useState<Promo[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        getRepPromo();
    }, [allTag]);

    let query: string = '';
    let activeAll = 'Active';

    if (allTag) {
        query = 'true';
        activeAll = 'All';
    };

    const getRepPromo = async() => {
        try {
            setLoading(true);

            const params = new URLSearchParams();
            
            if (currentWriter) params.append('writerId', currentWriter);
            if (allTag) params.append('all', query);

            console.log(params.toString())
            const response = await fetch(`${baseUrl}?${params.toString()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`),
                }
            });

            const json = await response.json();

            if (!response.ok) {
                throw new Error(`Unable to fetch data`)
            }

            if (!json?.ack) {
                throw new Error(`Error: ${json.errorMessage}`)
            }
            
            setRepPromo(Array.isArray(json?.promos) ? json.promos : []);
            console.log('RepPromosModal Res:', json.promos)
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ flex: 1 }}>
            <Modal
                isOpen={visible}
                onClosed={onClose}
                fullscreen
                unmountOnClose
            >
                <ModalHeader
                    className='bg-primary d-flex justify-content-center'
                    style={{ color: 'white', }}
                >
                    <Button 
                        title='Close'
                        onClick={onClose}
                        className="bg-transparent border-0 fw-bold text-white position-absolute start-0 ms-2"
                    >
                        Close
                    </Button>

                    <span style={{ color: 'white', fontWeight: 'bold', fontSize: 18,}}>Employee Promos</span>
                    {currentWriter && 
                        <span style={{ color: 'red', fontWeight: 'bold', fontSize: 18,}}>{" "}({currentWriter})</span>
                    }
                </ModalHeader>
                <ModalHeader className='d-flex justify-content-center border-0'>
                    <div 
                        className='pt-3 bg-white text-center d-block'
                    >
                        {repPromo.length > 0 && (
                            <span className='headerText'>
                                {toTitleCase(repPromo[0]?.NAME)}
                            </span>
                        )}
                        <div style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                            <span style={{ fontWeight: 'bold', textAlign: 'center' }}>{`${activeAll} Promos`}</span>
                            <Switch 
                                checked={allTag}
                                onChange={() => setAllTag(!allTag)}
                                sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                    color: '#f1b434',
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                    backgroundColor: '#f1b434',
                                    },
                                }}
                            />
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {loading ? (<Loading />)
                    : (
                        <Container style={{ flex: 1 }}>
                            {repPromo.length > 0 
                                ?
                                (
                                    <div>
                                        {repPromo
                                        .filter(Boolean)
                                        .map((promo: Promo) => (
                                            <Row 
                                                className='itemContainer shadow border text-center bg-white py-2' 
                                                key={promo?.PROMO}
                                            >
                                                <span style={{ fontWeight: 'bold' }}>{promo.PROMO}</span>
                                                <span>{promo.DESC}</span>
                                                <div style={{ flexDirection: 'row', paddingTop: 10}}>
                                                    <span style={{ fontWeight: 'bold' }}>Points: </span>
                                                    <span>{promo['TOT_PTS']}</span>
                                                </div>
                                                <div style={{ flexDirection: 'row', paddingTop: 10}}>
                                                    <span style={{ fontWeight: 'bold' }}>Dollars: </span>
                                                    <span>${promo.DOLLARS}</span>
                                                </div>
                                                <div style={{ flexDirection: 'row'}}>
                                                    <span style={{ fontWeight: 'bold' }}>Units: </span>
                                                    <span>{promo.UNITS}</span>
                                                </div>
                                                <div style={{ flexDirection: 'row'}}>
                                                    <span style={{ fontWeight: 'bold' }}>Start: </span>
                                                    <span>{promo["PROMO_START_DT"]}</span>
                                                </div>
                                                <div style={{ flexDirection: 'row'}}>
                                                    <span style={{ fontWeight: 'bold' }}>Ends: </span>
                                                    <span>{promo["PROMO_END_DT"]}</span>
                                                </div>
                                            </Row>
                                        ))}
                                    </div>
                                )
                                :
                                (
                                    <div style={{ marginTop: 10 }}>
                                        <span className='headerText'>You do not have any active promo data.</span>
                                    </div>
                                )
                            }
                        </Container>
                    )}  
                </ModalBody>
            </Modal>
        </div>
    )
};

export default RepPromosModal;